"use client";

import { useTranslations } from "next-intl";

import { FakeProgressBarV2 } from "@ui/components/core/FakeProgressBar/FakeProgressBarV2";
import IconAudioFill from "@ui/central-icons/icons/IconAudioFill";
import { FileIcon } from "./FileIcon";

interface STTUploadingViewProps {
  uploadFileName: string | null;
}

export function STTUploadingView({ uploadFileName }: STTUploadingViewProps) {
  const t = useTranslations("ClientKeys.STTHero");

  return (
    <div className='tw-flex-1 tw-flex tw-flex-col'>
      <div className='tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-gap-[10px]'>
        <FileIcon icon={IconAudioFill} />
        <div className='tw-bg-[#F5F3F1] tw-rounded-[7px] tw-px-[10px] tw-py-[10px] tw-type-xs tw-text-black/60 tw-truncate tw-max-w-full'>
          {uploadFileName ?? "…"}
        </div>
      </div>

      <div className='tw-flex tw-flex-col tw-items-center tw-gap-[14px] tw-w-full tw-shrink-0'>
        <FakeProgressBarV2 duration={30} />
        <p className='tw-type-xs tw-text-black/60'>{t("transcribing")}</p>
      </div>
    </div>
  );
}

export default STTUploadingView;
